<template>
  <div class="container">
    <QueryFrame @handlePage="handlePage" @handlePageSize="handlePageSize" :count="count"
      :current="page">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>患者姓名:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable
              v-model.trim="query.patientName"></lk-input>
          </div>
          <div class="queryItem">
            <label>咨询药师:</label>
            <lk-select class="item" filterable placeholder="请选择"
              v-model.trim="query.inquiryApothecary">
              <lk-option v-for="(item,i) in apothecaryList" :key="i" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>咨询时间:</label>
            <timeStampDatePicker type='daterange' class="item" clearable
              v-model.trim="query.duration"></timeStampDatePicker>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>创建门店:</label>
            <StoreListSelect :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.storeIdList'></StoreListSelect>
          </div>
          <div class="queryItem">
            <label>药品名称:</label>
            <!-- <lk-input :maxlength="100" placeholder="请输入" class="item" clearable
              v-model.trim="query.name"></lk-input> -->
               <lk-select  v-model="query.goodsStoreId" filterable class="item" clearable
              remote :remote-method="getGoods" :loading="goodsLoading">
              <lk-option v-for="(item,i) in goodsList" :key="i" :value='item.goodsStore.id*1'>{{item.goodsBaseVO.goodsBase.approvedDrugNames}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btnContainer">
          <lk-button @click="launchModal(0)" icon='md-add'
            v-if="handlePermission('patientInquiryAdd')" type='primary'>添加用药咨询记录</lk-button>
          <DownloadButton @on-click="download"
            v-if="handlePermission('patientInquiryExport')">
          </DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <lk-modal v-model="modal" :title="titleList[modalType]+'用药咨询记录'"
    :mask-closable='false'
    :closable='false'
    >
      <lk-form ref="queryInfo" :model='queryInfo' :rules='validate' :label-width='110'
        label-position="right">

        <lk-row :gutter='16'>
          <lk-form-item label='患者姓名:' prop='patientName'>
            <PatientSearch :val='queryInfo.patientName' v-if="[0,1].includes(modalType)" placeholder='请输入患者姓名'
              :saveValue='true' @selected='setPatientName' :getDataFunc='getPatientList'>
            </PatientSearch>
            <span v-else>{{queryInfo.patientName}}</span>
          </lk-form-item>
          <lk-form-item label='联系方式:' prop='patientPhone'>
            <lk-input :disabled='disabledPatientPhone' v-if="[0,1].includes(modalType)"
              v-model="queryInfo.patientPhone"></lk-input>
            <span v-else>{{queryInfo.patientPhone}}</span>
          </lk-form-item>
          <lk-form-item label='咨询药师:' prop='inquiryApothecary'>
            <lk-select v-if="[0,1].includes(modalType)" filterable
              v-model="queryInfo.inquiryApothecary">
              <lk-option v-for="(item,i) in apothecaryList" :key="i" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
            <span v-else>{{queryInfo.inquiryApothecaryName}}</span>
          </lk-form-item>
          <lk-form-item label='咨询时间:' prop='inquiryTime'>
            <timeStampDatePicker v-if="[0,1].includes(modalType)" v-model="queryInfo.inquiryTime">
            </timeStampDatePicker>
            <span v-else>{{queryInfo.inquiryTime|formatDate}}</span>
          </lk-form-item>
          <lk-form-item label='相关药品:' prop='' v-if="modal">
            <lk-select v-if="[0,1].includes(modalType)" v-model="queryInfo.goodsStoreIds" filterable
              remote multiple :remote-method="getGoods" :loading="goodsLoading">
              <lk-option v-for="(item,i) in goodsList" :key="i" :value='item.goodsStore.id*1'>
                {{item.goodsBaseVO.goodsBase.approvedDrugNames}}</lk-option>
            </lk-select>
            <span v-else>{{queryInfo.goodsNames}}</span>
          </lk-form-item>
          <lk-form-item label='咨询内容摘要:' prop='inquiryContent'>
            <lk-input type='textarea' v-if="[0,1].includes(modalType)"
              v-model="queryInfo.inquiryContent"></lk-input>
            <span v-else>{{queryInfo.inquiryContent}}</span>
          </lk-form-item>
          <lk-form-item label='咨询答复摘要:' prop='responseContent'>
            <lk-input type='textarea' v-if="[0,1].includes(modalType)"
              v-model="queryInfo.responseContent"></lk-input>
            <span v-else>{{queryInfo.responseContent}}</span>
          </lk-form-item>
        </lk-row>

      </lk-form>
      <div slot="footer">
        <lk-button @click="closeModel">取消</lk-button>
        <lk-button  v-if="[0,1].includes(modalType)" type='primary' :loading='submitLoading' @click="submit">确认</lk-button>
      </div>

    </lk-modal>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import system from '../../services/system';
import base from '../../services/base';
import goods from '../../services/goods';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

import DownloadButton from '../../components/download/DownloadButton';
import PatientSearch from '../../components/prescription/PatientSearch.vue';

export default {
  name: 'PatientInquiryList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton, PatientSearch,
  },
  data() {
    return {
      patientList: [],
      modal: false,
      modalType: 0,
      titleList: [
        '添加',
        '编辑',
        '查看',
      ],
      query: {
        duration: [],
      },
      queryInfo: {
        goodsStoreIds: [],
        inquiryTime: new Date().getTime(),
      },
      validate: {
        patientName: [{ required: true, message: '请选择患者', trigger: 'change' }],
        inquiryApothecary: [{ required: true, message: '请选择咨询药师' }],
        patientPhone: [{ required: true, message: '请填写联系方式' }, { validator: utils.validate.phoneValidator, trigger: 'blur' }],

        inquiryTime: [{ required: true, message: '请选择咨询时间' }],
        inquiryContent: [{ required: true, message: '请填写咨询内容摘要' }],
        responseContent: [{ required: true, message: '请填写咨询答复摘要' }],
      },
      columns: [
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '患者ID', key: 'patientId', minWidth: 116 },
        { title: '患者姓名', key: 'patientName', minWidth: 116 },
        { title: '患者联系方式', key: 'patientPhone', minWidth: 116 },
        {
          title: '咨询药师',
          key: 'inquiryApothecaryName',
          minWidth: 116,

        },
        {
          title: '咨询时间',
          key: 'inquiryTimeStr',
          minWidth: 116,
        },
        { title: '药品名称', key: 'goodsNames', minWidth: 116 },
        { title: '问题摘要', key: 'inquiryContent', minWidth: 116 },
        { title: '回答摘要', key: 'responseContent', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },

        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('patientInquiryCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.getInfo(params.row.id, true).then((res) => {
                    this.launchModal(2, res);
                  });
                },
              },
            }, '查看') : null,
            this.handlePermission('patientInquiryEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  // params.row.goodsStoreIds = Array.isArray(params.row.goodsStoreIds) || (params.row.goodsStoreIds && params.row.goodsStoreIds.split(','));
                  console.log(params);

                  this.getInfo(params.row.id, false).then((res) => {
                    this.goodsList = res.goodsList && res.goodsList.map(sub => ({
                      goodsStore: { id: sub.goodsStoreId * 1 },
                      goodsBaseVO: {
                        goodsBase: {
                          approvedDrugNames: sub.approvedName,
                        },
                      },
                    }));
                    // res.goodsList;
                    console.log(res);
                    // this.$nextTick(() => {
                    this.launchModal(1, res);
                    // });
                  }).catch((err) => {
                    utils.handleError(err);
                  });
                  // this.launchModal(1, params.row);
                },
              },
            }, '修改') : null,
          ]),
        },
      ],
      tableData: [],
      apothecaryList: [], // 管理省份列表
      goodsList: [],
      goodsLoading: false,
      patientLoading: false,
      submitLoading: false,
      disabledPatientPhone: false,
    };
  },
  methods: {
    setPatientName(selected) {
      // if (this.pa) {

      // }
      console.log(selected);

      this.queryInfo.patientName = selected.name;
      // if (!selected.name) {

      // }


      if (!selected.name || selected.id) {
        this.queryInfo.patientId = selected.id;
        this.queryInfo.patientPhone = selected.phone;
        this.disabledPatientPhone = !!selected.phone;
      }
    },
    // patientFilter(value, option) {
    //   this.getPatientList(value);
    //   console.log(value);
    //   console.log(option);
    //   return true;
    // },
    launchModal(type, info) {
      this.modalType = type;
      this.modal = true;

      this.$nextTick(() => {
        const isApothecary = !!this.user.roles.find(item => item.id === 3);// 判定是否为药师
        this.queryInfo = {
          goodsStoreIds: [],
        };
        this.$refs.queryInfo.resetFields();
        this.queryInfo.inquiryTime = new Date().getTime();
        if (info) {
          this.queryInfo = utils.deepClone(info.patientInquiry);
          this.queryInfo.goodsNames = info.goodsNames;
          this.disabledPatientPhone = !!this.queryInfo.patientPhone;
        }
        if (type === 0) {
          this.disabledPatientPhone = false;
          if (isApothecary) {
            // this.queryInfo.inquiryApothecary = this.user.info.id;
            this.$set(this.queryInfo, 'inquiryApothecary', this.user.info.id);
          }
        }
      });
    },
    getApothecaryList() {
      return new Promise((resolve) => {
        system.listUserByRole({
          // page: 1,
          // size: 100,
          // // roleId: 3,
          // // majorType: 1,
          // statusCodeList: [1],
          roleId: 3,
        }).then((res) => {
          if (res.data.status === 200) {
            // this.diseaseList = res.data.data;
            // const list = [];
            // res.data.data.list.forEach((item) => {
            //   list.push(item); // 抽取sysUser
            // });
            this.apothecaryList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getInfo(patientInquiryId, encrypt) {
      return new Promise((resolve, reject) => {
        base.patient.getPatientInquiryInfo({ patientInquiryId, encrypt }).then((res) => {
          if (res.data.status === 200) {
            const { data } = res.data;
            data.patientInquiry.goodsStoreIds = data.patientInquiry.goodsStoreIds && data.patientInquiry.goodsStoreIds.split(',').map(id => id * 1);


            resolve(data);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
    formatParams(params) {
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      if (temp.duration.length) {
        temp.inquiryTimeStart = temp.duration[0];
        temp.inquiryTimeEnd = temp.duration[1];
      }
      return temp;
    },
    getData() {
      const params = this.formatParams(this.params);

      params.encrypt = true;

      this.$route.params.create ? params.create = true : params.create = '';

      base.patient.getPatientInquiryList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            console.log(item);

            const result = {};
            utils.exchangeTable(item.patientInquiry, result);
            result.loading = false;
            result.goodsNames = item.goodsNames;
            result.inquiryTimeStr = utils.formatTime(result.inquiryTime);
            result.createTime = utils.formatTime(result.createTime);
            // result.goodsStoreIds = result.goodsStoreIds && result.goodsStoreIds.split(',').map(id => id * 1);
            // console.log(result.goodsStoreIds);

            // result.goodsList = item.goodsList && item.goodsList.map(sub => ({
            //   goodsStore: { id: sub.goodsStoreId * 1 },
            //   goodsBaseVO: {
            //     goodsBase: {
            //       approvedDrugNames: sub.approvedName,
            //     },
            //   },
            // }));
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    closeModel() {
      // this.$refs.queryInfo.resetFields();

      this.modal = false;
    },
    clear() {
      this.query = {
        duration: [],
      };
    },

    download() {
      // const params =
      const params = this.formatParams(this.params);

      params.page = 0;
      params.size = 0;
      // params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      // delete params.duration;
      params.queryCondition = utils.getQueryCondition('.queryContainer');

      base.patient.downloadPatientInquiryList(params).then((res) => {
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    getGoods(name) {
      this.goodsLoading = true;
      goods.listGoodsStores({ nameMix: name }).then((res) => {
        if (res.data.status === 200) {
          this.goodsList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
        this.goodsLoading = false;
      }).catch((err) => {
        this.goodsLoading = false;
        utils.handleError(err);
      });
    },

    submit() {
      this.$refs.queryInfo.validate((valid) => {
        console.log(valid);

        if (valid) {
          let submitFunc = null;
          if (this.modalType === 0) {
            submitFunc = base.patient.addPatientInquiry;
          } else if (this.modalType === 1) {
            submitFunc = base.patient.editPatientInquiry;
          }


          const patientInquiry = utils.deepClone(this.queryInfo);
          console.log(patientInquiry.goodsStoreIds);

          const goodsList = patientInquiry.goodsStoreIds.length && patientInquiry.goodsStoreIds.map(item => ({
            goodsStoreId: item,
          }));

          console.log(1);
          delete patientInquiry.goodsStoreIds;
          delete patientInquiry.createTime;
          console.log(2);


          patientInquiry.inquiryApothecaryName = patientInquiry.inquiryApothecary && this.apothecaryList.find(item => item.id === patientInquiry.inquiryApothecary).name;
          // patientInquiry.patientName = patientInquiry.patientId && this.patientList.find(item => item.id === patientInquiry.patientId).name;


          this.submitLoading = true;


          submitFunc(goodsList ? {
            patientInquiry, goodsList,
          } : {
            patientInquiry,
          }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
            } else {
              this.$Message.error(res.data.error);
            }
            this.submitLoading = false;
            this.modal = false;
            this.getData();
          }).catch((err) => {
            this.submitLoading = false;
            utils.handleError(err);
          });
        }
      });
    },
    getPatientList(name) {
      return new Promise((resolve, reject) => {
        base.patient.getPatientList({ name }).then((res) => {
          if (res.data.status === 200) {
            resolve(res.data.data.list.map(item => item.patient));
            // this.patientList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
        // this.patientLoading = false;
          reject(err);
          utils.handleError(err);
        });
      });


      // this.patientLoading = true;
    },

  },
  mounted() {
    this.getApothecaryList().then(() => {
      // this.getNation();
      this.handleSearch(true);
    });
  },
};
</script>
<style lang="less" scoped>
.btnContainer{
  margin-bottom: 12px;
  margin-top:2px;
  >*:first-child{
    margin-right: 8px
  }

}
  .queryContainer{
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
</style>
